import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/shared/styles/globals.css";
import "@/i18n";
import { initAnalytics } from "@/shared/lib/analytics";
import { App } from "./App";

initAnalytics();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error('Root element "#root" not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
